import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ModulesType } from 'components/filter/models/TableFilterModels';
import alb from 'services/api/alb';

import { ProcessType } from '../types/recalculateRestricted.dto';

export interface IResponseRecalculate {
	is_slow: boolean;
}

const processTypeToUrl: Record<ProcessType, string> = {
	[ProcessType.RECALCULATE_RESTRICTED_PLAN]: 'recalculate',
	[ProcessType.CALCULATE_RESTRICTED_PLAN]: 'calculate',
};
interface IRecalculateOrCalculateUnrestrictedPlanProps {
	cycleId: number;
	process_type: ProcessType;
}
export const recalculateOrcalculateUnrestrictedPlan = async ({
	cycleId,
	process_type,
}: IRecalculateOrCalculateUnrestrictedPlanProps): Promise<IResponseRecalculate> => {
	const url = `/restricted-plan/${processTypeToUrl[process_type]}`;
	const response: AxiosResponse<IResponseRecalculate> = await alb.post(url, {
		cycle_id: cycleId,
	});
	return response.data;
};

export const useRecalculateRestrictedPlan = (
	isSlow: boolean = false,
	onSuccess: () => void
) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(
		(body: IRecalculateOrCalculateUnrestrictedPlanProps) =>
			recalculateOrcalculateUnrestrictedPlan(body),
		{
			onSuccess: (_, { process_type: processType }) => {
				if (!isSlow) {
					toast({
						title: `Plano restrito ${
							processType ===
							ProcessType.RECALCULATE_RESTRICTED_PLAN
								? 'recalculado'
								: 'gerado'
						} com sucesso!`,
						position: 'bottom-left',
						status: 'success',
						duration: 8000,
						isClosable: true,
					});
					const module: ModulesType = 'restricted-plan';
					queryClient.invalidateQueries({
						queryKey: [`${module}-list`],
					});
				} else {
					onSuccess();
				}
				queryClient.invalidateQueries({
					queryKey: [`verify-job-is-pending`],
				});
			},
			onError: (
				error: any,
				{
					process_type: processType,
				}: IRecalculateOrCalculateUnrestrictedPlanProps
			) => {
				toast({
					title: `Erro ao ${
						processType ? 'recalcular' : 'gerar'
					} plano restrito`,
					description: error.response.data.message,
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			},
		}
	);
};
